import { MutualFundTradingServiceStrategy } from './mutualfund-trading-service-strategy.service';
import { TRADING_PLATFORM } from '../../utils/trading-constants';
import { CdscFeeRequestWrapper, CdscFee, MutualfundTradingOrder } from '../../models/mutualfund/trading-mutualfund.model';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { Account, AccountType, TransactionType } from '../../models';

@Injectable()
export class ProfessionalMutualFundTradingServiceStrategy extends MutualFundTradingServiceStrategy {
    private static SUPPORTED_PLATFORM = TRADING_PLATFORM.PROFESSIONAL;

    support(platform: string): boolean {
        return ProfessionalMutualFundTradingServiceStrategy.SUPPORTED_PLATFORM === platform;
    }

    public getAccountTypes(account: Account, transactionType: TransactionType): AccountType[] {
        const isMarginEnabledAccount: boolean = account.acctMarginInd === 'Y' || account.applicantMarginCd === '001';
        if (account.custodianCd === 'BNYM') {
            return [AccountType.CASH];
        }

        if ( transactionType === TransactionType.BUY ) {
            return [AccountType.CASH];
        }

        if ( isMarginEnabledAccount) {
            return [AccountType.CASH, AccountType.MARGIN];
        }
        return [AccountType.CASH];

    }

    public getCdscFee(cdscFeeRequestWrapper: CdscFeeRequestWrapper): Observable<CdscFee> {
        let cdscFeeUrl: string = this.getBaseUrl() + '/' + this.acctNumParam + '/' + cdscFeeRequestWrapper.fundFamilyId
            + '/' + cdscFeeRequestWrapper.cusip + '/cdsc-fee';
        cdscFeeUrl += '?transactionType=' + cdscFeeRequestWrapper.transactionType;

        if (cdscFeeRequestWrapper.tradeInShares) {
            cdscFeeUrl += '&redemptionShareCount=' + cdscFeeRequestWrapper.shareQty;
        } else {
            cdscFeeUrl += '&redemptionDollarAmount=' + cdscFeeRequestWrapper.dollarQty;
        }

        if (cdscFeeRequestWrapper.grossNetIndicator) {
            cdscFeeUrl += '&grossNetIndicator=' + cdscFeeRequestWrapper.grossNetIndicator;
        }

        if (cdscFeeRequestWrapper.contingentDeferredSalesCharge) {
            cdscFeeUrl += '&contingentDeferredSalesCharge=' + cdscFeeRequestWrapper.contingentDeferredSalesCharge;
        }

        if (cdscFeeRequestWrapper.contingentDeferredManagementId) {
            cdscFeeUrl += '&contingentDeferredManagementId=' + cdscFeeRequestWrapper.contingentDeferredManagementId;
        }

        return this.http.get(cdscFeeUrl, { headers: this.getHttpHeadersWithAcctNum(cdscFeeRequestWrapper.acctNum) });
    }

    public getLoiRoaDetails(acctNum: string, symbol: string, cusip: string, type: string): Observable<any> {
        let loiRoaDtlUrl: string = this.getBaseUrl() + '/' + this.acctNumParam + '/' + symbol + '/' + cusip + '/' + type.toUpperCase() + '/loi-roa';

        return this.http.get(loiRoaDtlUrl, { headers: this.getHttpHeadersWithAcctNum(acctNum) });
    }

    public editMutualFundOrder(mutualFundTradingOrder: MutualfundTradingOrder): Observable<any> {
        throw new Error('Edit is not supported on the professional platform');
    }
}
